module.exports = __webpack_public_path__ + "media/slide-2.e5c9127f.mp4";